// frontend/src/components/ReviewForm.jsx

import React, { useState } from 'react';
import fetchData from '../../api/fetchData';
import {  useTranslation } from 'react-i18next'; 
import './ReviewForm.css'; 


function ReviewForm({ onReviewAdded, onClose }) {
  const { t, i18n } = useTranslation();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState(''); 
  const [isSubmitting, setIsSubmitting] = useState(false); 

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); 
     setStatus({ type: 'info', messageKey: 'reviewsForm.submitButton.submitting' });

    try {
     const response = await fetchData(
        '/public/add_review.php', 
        'POST',            
        { name, email, message, language_code: i18n.language },
        { credentials: 'include' } 
      );

      if (response && response.status === 'success') {
        setStatus({type : 'success', messageKey: 'reviewsForm.successMessage' });
        setName('');
        setEmail('');
        setMessage('');

       if (onReviewAdded) onReviewAdded();

        setTimeout(() => {
          if (onClose) onClose();
        }, 3000);

      } else {
        const errorDetails = response?.message || t('reviewsForm.fallbackError');
        setStatus({ type: 'error', messageKey: 'reviewsForm.genericError', details: errorDetails });
        setIsSubmitting(false); 
      }
    } catch (err) {
     const errorDetails = err.message || t('reviewsForm.fallbackError');
     
     setStatus({
    type: 'error',
    messageKey: 'reviewsForm.genericError', 
    details: errorDetails 
  });
  setIsSubmitting(false);
    }
  };

  return (
      <div className="review-form-container"> 
        {onClose && (
          <button onClick={onClose} className="close-button">
            &times; 
          </button>
        )}

        <h3>{t('reviewsForm.title')} </h3>
        <form onSubmit={handleSubmit} className="review-form">
          <div className="form-group">
            <label htmlFor="name">{t('reviewsForm.nameLabel')}:</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              disabled={isSubmitting}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="email"> {t('reviewsForm.emailLabel')}:</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isSubmitting}
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">{t('reviewsForm.reviewLabel')}:</label>
            <textarea
              id="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows="5"
              required
              disabled={isSubmitting}
            ></textarea>
          </div>

          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? t('reviewsForm.submitButton.submitting') : t('reviewsForm.submitButton.idle')}
          </button>
        </form>

        {status && (
          <p className={`form-status-message ${status.type}`}>
            {t(status.messageKey, { details: status.details })}
          </p>
        )}
      </div>
  );
}

export default ReviewForm;